export const detailsPageTabs = ["summary", "recipients", "content", "timing"] as const;

export type DetailsPageTab = (typeof detailsPageTabs)[number];

export type SaveAction = "save" | "saveAndExit";

export type CommunicationImageSource =
  | { kind: "saved"; communicationId: string; fileId: string }
  | { kind: "local"; url: string; fileName: string }
  | { kind: "url"; url: string };

export const getImageSourceKey = (source: CommunicationImageSource): string =>
  source.kind === "saved" ? source.fileId : source.url;
